module.exports = __webpack_public_path__ + "assets/pdf/E09-cn-seasonal-forecast.8e292080.pdf";